import { forwardRef, useMemo } from "react";
import { useSelector } from "react-redux";
import IconButton from "../../../../components/IconButton";
import PlayButton from "../../../../components/buttons/PlayButton";
import { generateTimeWindowsText } from "../../../../components/time-windows/TimeWindows";
import {
  OPENING_HOURS_KEY,
  TEXT_KNOWLEDGE_ITEM_KEY,
  validateKnowledgeBaseItem,
} from "../../../../services-logic/knowledge-base/knowledge-base-logic";
import AccordionHeader from "../../../common-components/AccordionHeader";

const ICONS = {
  [OPENING_HOURS_KEY]: {
    icon: "/assets/icons/common/opening-hours.svg",
    size: "size-6",
  },
  [TEXT_KNOWLEDGE_ITEM_KEY]: {
    icon: "/assets/icons/common/text-knowledge-item.svg",
    size: "size-6 p-0.5",
  },
};

const KnowledgeBaseAccordionHeader = forwardRef(({ item, index, isActive, onDelete }, ref) => {
  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const { knowledgeItemErrors } = useSelector((state) => state.knowledgeBase);
  const voices = useSelector((state) => state.info.voices);
  const selectedVoice = voices?.find((voice) => voice.id === updatedVoice);

  const validationMessage = () => {
    if (
      !knowledgeItemErrors[index] ||
      Object.keys(knowledgeItemErrors[index]).length === 0 ||
      Object.keys(knowledgeItemErrors[index]).every((key) => knowledgeItemErrors[index][key] === "")
    ) {
      return "";
    }

    const validation = validateKnowledgeBaseItem(item, index);

    if (!validation.valid) {
      return validation.message;
    }
    return "";
  };

  const prefixIcon = useMemo(() => ICONS[item.type] || "", [item.type]);

  const getTextToPlay = useMemo(() => {
    if (selectedVoice?.enablePreview === false) {
      return "";
    }

    switch (item.type) {
      case OPENING_HOURS_KEY:
        return generateTimeWindowsText(item.value, "Our opening hours are");
      case TEXT_KNOWLEDGE_ITEM_KEY:
        return validateKnowledgeBaseItem(item, index).valid ? `${item.value}` : "";
      default:
        return "";
    }
  }, [item]);

  const actionsChildren = (
    <div className="flex gap-2 items-center justify-center">
      <PlayButton
        type="simple"
        voice={selectedVoice?.id}
        id={`knowledge-base-${index}`}
        text={getTextToPlay}
        iconSize="size-5"
        preventPropagation={isActive}
      />
      <IconButton
        iconSize="size-5"
        icon={"/assets/icons/actions/delete.svg"}
        hoverIcon={"/assets/icons/actions/delete-hover.svg"}
        onClick={(event) => {
          event?.stopPropagation();
          onDelete(index);
        }}
      />
    </div>
  );

  return (
    <AccordionHeader
      ref={ref}
      prefixIcon={prefixIcon.icon}
      prefixIconSize={prefixIcon.size}
      title={item.title}
      subtitle={item?.subtitle}
      isActive={isActive}
      actionsChildren={actionsChildren}
      validationMessage={validationMessage()}
    />
  );
});

export default KnowledgeBaseAccordionHeader;
